import Vue from 'vue';
import ElementUI from '@baidu/acud-element-ui';
import '@baidu/acud-element-theme';
import enLang from '@baidu/acud-element-ui/lib/locale/lang/en';
import VueClipboard from 'vue-clipboard2';
// @ts-ignore
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

import {prepareLanguage} from '@/utils/bootstrap';
import '@/common/ClassComponentHooks';
import '@/common/monitor'; // 添加监控
import useDirective from '@/utils/directive';
import '@/styles/reset.scss';
import 'driver.js/dist/driver.css';
import App from './App.vue';
import pligins from './common/plugin';
import i18n, {locale} from './i18n';
import router from './router';
import store from './store';
import useLoadMore from './directives/loadmore';
// @ts-ignore
import ZSvgIcon from '@/znzs/new_src/components/SvgIcon';
// @ts-ignore
import useZnzsMorph from '@/znzs/new_src/directives/morph';
// @ts-ignore
import {appTag} from '@/znzs/src/utils/env';

const VueMasonryPlugin = require('vue-masonry').VueMasonryPlugin;

Vue.config.productionTip = false;

Vue.use(VueMasonryPlugin);
// OPT: 给 VueDOMPurifyHTML 提PR，替换为这个
// Vue.use(VueDOMPurifyHTML);
useDirective(Vue);
useLoadMore(Vue);
Vue.use(VueClipboard);
Vue.use(Viewer);
Vue.use(ZSvgIcon);
useZnzsMorph(Vue);
Vue.prototype.$appTag = appTag;
// znzs 埋点指令 — ticket-plat 不接入 FEMonitor，注册空壳避免 warn
Vue.directive('znzs-logger', {});
// 加载 znzs SVG 图标资源
const znzsSvgReq = require.context('@/znzs/new_src/assets/svg/', false, /\.svg$/);
znzsSvgReq.keys().forEach(znzsSvgReq);

prepareLanguage().then((localeStr: string) => {
    if (localeStr) {
        i18n.locale = localeStr;
    }
    // plugin中包含与语言相关的设置，所以放到这里
    Vue.use(pligins);
    Vue.use(ElementUI, {locale: locale.isEnglish ? enLang : undefined});
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
    }).$mount('#app');
});
